export const DubaiImages ={
    d1 : require('./portdubai1.jpg').default,
    d2 : require('./portdubai2.jpg').default,
    db1 : require('./dbeach1.jpg').default,
    db2 : require('./dbeach2.jpg').default,
    dc1 : require('./dculture1.jpg').default,
    dc2 : require('./dculture2.jpg').default,
    dh1 : require('./dhotel1.jpg').default,
    dh2 : require('./dhotel2.jpg').default,
    dp1 : require('./dpack1.jpg').default,
    dp2 : require('./dpack2.jpg').default,
    dp3 : require('./dpack3.jpg').default,
    dp4 : require('./dpack4.jpg').default,
    do1 : require('./onlydubai.jpg').default,
    do2 : require('./onlydubai2.jpg').default,
}